import * as WebAuthnJSON from "@github/webauthn-json";

function getCSRFToken() {
  var CSRFSelector = document.querySelector('meta[name="csrf-token"]');
  if (CSRFSelector) {
    return CSRFSelector.getAttribute("content");
  } else {
    return null;
  }
}

function callback(url, body, redirect_url) {
  fetch(url, {
    method: "POST",
    body: JSON.stringify(body),
    headers: {
      "Content-Type": "application/json",
      Accept: "application/json",
      "X-CSRF-Token": getCSRFToken(),
    },
    credentials: "same-origin",
  }).then(function (response) {
    if (response.ok) {
      window.location.replace(redirect_url);
    } else if (response.status < 500) {
      response.text().then(console.log);
    } else {
      console.log("Sorry, something wrong happened.");
    }
  });
}

function create(callbackUrl, credentialOptions) {
  WebAuthnJSON.create({ publicKey: credentialOptions })
    .then(function (credential) {
      callback(callbackUrl, credential, "/");
    })
    .catch(function (error) {
      console.log(error);
      var userCancelledError = "NotAllowedError";
      if (error.toString().includes(userCancelledError)){
        // User cancelled the operation, do nothing
      } else {
        alert("An error occurred, such as the device has already been registered. Try visiting the main login url. Details: " + error);
      }
    });

  console.log("Creating new public key credential...", credentialOptions, callbackUrl);
}

function get(credentialOptions) {
  WebAuthnJSON.get({ publicKey: credentialOptions })
    .then(function (credential) {
      callback("/webauthn_credential_authentication", credential, "/");
    })
    .catch(function (error) {
      console.log(error);
    });

  console.log("Getting public key credential...");
}

export { create, get };
